<template>
    <v-dialog v-model="objFormBeneModal.abrirModal" :max-width="tamModal" :scrollable="$root.isTouch == false"
        :fullscreen="$root.isTouch" persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card"> <span class="white--text headline"
                    v-html="objFormBeneModal.titulo"></span></v-card-title>
            <v-card-text>
                <v-form ref="form_beneficio" :lazy-validation="false">
                    <v-container fluid grid-list-sm>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Tipo Beneficio *" color="textbox"
                                    v-model="objFormBeneModal.idTipoBeneficio"
                                    :items="listGeneralModal.listTipoBeneficio" item-value="idTipoBeneficio"
                                    item-text="tipoBeneficio" :rules="requeridoRegla" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Proveedor *" color="textbox"
                                    v-model="objFormBeneModal.idProveedor" :items="listGeneralModal.listProveedores"
                                    item-value="idProveedor" item-text="proveedor" :rules="requeridoRegla" outlined
                                    dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="8">
                                <v-text-field label="Beneficio *" color="textbox" v-model="objFormBeneModal.nombre"
                                    :rules="_.concat(requeridoRegla,soloLetrasRegla(1,objFormBeneModal.nombre,300))"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-row dense>
                                    <v-col cols="2" sm="1">
                                        <v-tooltip right color="primary">
                                            <template v-slot:activator="{ on }">
                                                <v-icon class="mt-3" color="primary"
                                                    @click="abrirVentana($event,'logoWeb')" v-html="'cloud_upload'"
                                                    v-on="on" />
                                                <input type="file" style="display: none;" ref="logoWeb"
                                                    @change="obtenerFile($event,'base64')"
                                                    accept="image/svg+xml,image/jpeg, image/png" />
                                            </template>
                                            <span>Subir Icono</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="19" sm="11">
                                        <div class="text-center" v-show="_.size(objFormBeneModal.base64)">
                                            <img :src="objFormBeneModal.base64" alt="..." width="30%" />
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-textarea color="textbox" label="Mensaje de Notificación *"
                                    v-model="objFormBeneModal.notificacionPublica"
                                    :value="objFormBeneModal.notificacionPublica" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Cantidad de Beneficio por Asegurado *" color="textbox"
                                    v-model="objFormBeneModal.cantidad" :rules="_.concat(requeridoRegla,decimal)"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="No. de Asegurados que se beneficiaran *" color="textbox"
                                    v-model="objFormBeneModal.numeroAsegurados"
                                    :rules="_.concat(requeridoRegla,decimal)" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Estado *" color="textbox" v-model="objFormBeneModal.idEstado"
                                    :items="listGeneralModal.listEstados" item-value="id_estado"
                                    item-text="nombre_estado" :rules="requeridoRegla" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-dialog ref="dialogFechaIniVig" v-model="objDate.fechaIniVig.abrirModal"
                                    :return-value.sync="objFormBeneModal.fechaIniVig" persistent width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field color="textbox" v-model="objFormBeneModal.fechaIniVig"
                                            label="Fecha Inicio Vigencia *" :rules="requeridoRegla"
                                            prepend-inner-icon="event" readonly outlined dense v-on="on" />
                                    </template>
                                    <v-date-picker color="primary" v-model="objFormBeneModal.fechaIniVig" scrollable
                                        locale="es">
                                        <v-spacer></v-spacer>
                                        <v-btn outlined dense rounded color="danger"
                                            @click="objDate.fechaIniVig.abrirModal = false" v-text="'Salir'"></v-btn>
                                        <v-btn rounded dark color="primary"
                                            @click="$refs.dialogFechaIniVig.save(objFormBeneModal.fechaIniVig)"
                                            v-text="'Guardar Fecha'"></v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-dialog ref="dialogFechaFinVig" v-model="objDate.fechaFinVig.abrirModal"
                                    :return-value.sync="objFormBeneModal.fechaFinVig" persistent width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field color="textbox" v-model="objFormBeneModal.fechaFinVig"
                                            label="Fecha Fin Vigencia *" :rules="requeridoRegla"
                                            prepend-inner-icon="event" readonly outlined dense v-on="on" />
                                    </template>
                                    <v-date-picker color="primary" v-model="objFormBeneModal.fechaFinVig" scrollable
                                        locale="es">
                                        <v-spacer></v-spacer>
                                        <v-btn outlined dense rounded color="danger"
                                            @click="objDate.fechaFinVig.abrirModal = false" v-text="'Salir'"></v-btn>
                                        <v-btn rounded dark color="primary"
                                            @click="$refs.dialogFechaFinVig.save(objFormBeneModal.fechaFinVig)"
                                            v-text="'Guardar Fecha'"></v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>
                        <v-row class="mb-5">
                            <v-col cols="12">
                                <v-card flat>
                                    <v-container>
                                        <v-card-text>
                                            <fieldset class="px-3">
                                                <legend>Total a Pagar:</legend>
                                                <v-row dense class="mt-3">
                                                    <v-col cols="12" sm="4">
                                                        <v-text-field label="Cantidad " color="textbox"
                                                            v-model="objFormBeneModal.facturaCantidad"
                                                            :rules="_.size(objFormBeneModal.facturaCantidad) > 0 ? _.concat(requeridoRegla,decimal) : []"
                                                            outlined dense />
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <v-text-field label="Costo Individual " color="textbox"
                                                            v-model="objFormBeneModal.facturaCostoUni"
                                                            :rules="_.size(objFormBeneModal.facturaCostoUni) > 0 ? _.concat(requeridoRegla,decimal) : []"
                                                            outlined dense />
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <v-text-field label="Costo Total " color="textbox"
                                                            v-model="objFormBeneModal.facturaCosTot" readonly
                                                            outlined dense />
                                                    </v-col>
                                                </v-row>
                                            </fieldset>
                                        </v-card-text>
                                    </v-container>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="text-right">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="cargaGeneral(false)">
                                    Cancelar</v-btn>
                                <v-btn rounded dark color="primary" @click="insertarActualizar">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['objFormBene', 'listGeneral'],
        data() {
            return {
                objFormBeneModal: {
                    abrirModal: false
                },
                listGeneralModal: [],
                objDate: {
                    fechaIniVig: {
                        abrirModal: false
                    },
                    fechaFinVig: {
                        abrirModal: false
                    }
                }
            }
        },
        watch: {
            objFormBeneModal: {
                handler(val) {
                    if ((_.size(val.facturaCantidad) > 0) && (_.size(val.facturaCostoUni)) > 0)
                        val.facturaCosTot = val.facturaCantidad * val.facturaCostoUni;
                },
                deep: true
            }
        },
        methods: {
            cargaGeneral(activo) {
                if (activo) {
                    this.objFormBeneModal = _.merge({}, _.clone(this.objFormBene), {
                                                                                        abrirModal: true,
                                                                                        titulo: _.size(this.objFormBene.idBeneficio) == 0 ? 'Nuevo Beneficio' : 'Editar Beneficio'
                                                                                    });
                    this.listGeneralModal = _.clone(this.listGeneral);
                    this.listGeneral.listEstados = _.filter(this.listGeneral.listEstados, (v) => { return _.isEqual(v.visualiza, 'true') });
                    this.objFormBeneModal.fechaIniVig = _.size(this.objFormBeneModal.fechaIniVig) > 0 ? moment(this.objFormBeneModal.fechaIniVig).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                    this.objFormBeneModal.fechaFinVig = _.size(this.objFormBeneModal.fechaFinVig) > 0 ? moment(this.objFormBeneModal.fechaFinVig).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                } else { //Reset variables
                    this.$refs.form_beneficio.resetValidation();
                    this.objFormBeneModal = { abrirModal: false };
                    this.$parent.$parent.objFormBene = {
                        idTipoBeneficio: this.listGeneralModal.listTipoBeneficio[0].idTipoBeneficio,
                        idEstado: _.toString(this.$parent.$parent.idEstadoDefault)
                    };
                    this.listGeneralModal = [];
                    this.$forceUpdate();
                }
            },
            insertarActualizar() {
                try {
                    if (!this.$refs.form_beneficio.validate()) throw mensajeEstandar.corregirInformacion;
                    if (this.objFormBeneModal.fechaIniVig > this.objFormBeneModal.fechaFinVig) throw mensajeEstandar.rangoFechaIncorrecto;
                        this.$parent.$parent.objFormBene = _.merge({}, _.omit(this.objFormBeneModal, ['titulo',
                            'abrirModal', 'tipoBeneficio', 'proveedor'
                        ]), {
                            opcion: _.size(this.objFormBeneModal.idBeneficio) == 0 ? 'I' : 'U'
                        });
                        this.$parent.$parent.insertarActualizar();
                } catch (error) {
                    mensajesAlerta(error, 'I');
                }
            },
            abrirVentana(event, icono) {
                this.$refs[icono].click()
            },
            obtenerFile(e, atributo) {
                var file = e.target.files;
                try {
                    if (_.isUndefined(file[0])) throw mensajeEstandar.faltaArchivos;
                    if (file[0].name.lastIndexOf('.') <= 0) throw mensajeEstandar.archivo;
                    if (file[0].name.search('.svg') == -1 && file[0].name.search('.png') == -1 && file[0].name.search(
                            '.jpeg') == -1 && file[0].name.search('.jpg') == -1) throw mensajeEstandar.archivo;
                    const fr = new FileReader();
                    fr.readAsDataURL(file[0])
                    fr.addEventListener('load', () => {
                        this.$set(this.objFormBeneModal, atributo, fr.result);
                        this.$forceUpdate();
                    });
                } catch (e) {
                    mensajesAlerta(e, 'E');
                }
            }
        }
    }
</script>

<style>
    fieldset {
        /* background-color: rgba(111, 66, 193, 0.3); */
        border-radius: 4px;
    }

    legend {
        /* background-color: #fff; */
        border: 1px solid #ddd;
        border-radius: 4px;
        color: #000000;
        font-size: 17px;
        font-weight: bold;
        padding: 3px 5px 3px 7px;
        width: auto;
    }
</style>